var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingUpload
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingUpload = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row config-type-row card-body1"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "radio-inline config-type-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configType),
      expression: "configType"
    }],
    attrs: {
      "type": "radio",
      "name": "configType",
      "value": "trolley"
    },
    domProps: {
      "checked": _vm._q(_vm.configType, "trolley")
    },
    on: {
      "change": [function($event) {
        _vm.configType = "trolley"
      }, _vm.onConfigTypeChange]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "config-type-radio-label"
  }, [_vm._v("Trolley Config")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline config-type-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.configType),
      expression: "configType"
    }],
    attrs: {
      "type": "radio",
      "name": "configType",
      "value": "area"
    },
    domProps: {
      "checked": _vm._q(_vm.configType, "area")
    },
    on: {
      "change": [function($event) {
        _vm.configType = "area"
      }, _vm.onConfigTypeChange]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "config-type-radio-label"
  }, [_vm._v("Area Config")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1 col-md-12",
    staticStyle: {
      "margin-bottom": "0rem",
      "padding": "0px",
      "background-color": "white"
    }
  }, _vm._l((_vm.visibleTabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button', {
        active: _vm.currentTab === tab.key
      }],
      on: {
        "click": function($event) {
          return _vm.switchTab(tab)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.value) + "\n          ")])
  }), 0), _vm._v(" "), _c('fieldset', [(_vm.currentTab === 'config') ? _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onUploadSubmit.apply(null, arguments)
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.configTypeLabel))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('configFile')
    },
    attrs: {
      "type": "file",
      "placeholder": "Upload File",
      "name": "configFile",
      "id": "configFile"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Note: * Only .csv OR .zip files allowed to upload.")])], 1), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('configFile')),
      expression: "errors.has('configFile')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Upload file is required.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#20a8d8",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "javascript:void(0)",
      "title": 'Download ' + _vm.configTypeLabel + ' template CSV'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadSampleConfigFile.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" " + _vm._s(_vm.configTypeLabel) + " Template\n                   ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 expected-column"
  }, [_c('p', {
    staticClass: "expected-title"
  }, [_vm._v("Expected CSV columns")]), _vm._v(" "), _c('div', {
    staticClass: "column-tags"
  }, [_vm._l((_vm.configMeta.expectedHeaders), function(column, index) {
    return _c('span', {
      key: index,
      staticClass: "column-tag"
    }, [_vm._v("\n                        " + _vm._s(column) + "\n                      ")])
  }), _vm._v(" "), _vm._l(((_vm.configMeta.optionalHeaders || [])), function(column, index) {
    return _c('span', {
      key: 'optional-' + index,
      staticClass: "column-tag"
    }, [_vm._v("\n                        " + _vm._s(column) + " (Optional)\n                      ")])
  })], 2)]), _vm._v(" "), (_vm.failed.length > 0) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v(" ")]), _c('b-input-group', [_c('span', {
    staticStyle: {
      "margin-left": "50%",
      "font-size": "25px"
    }
  }, [_vm._v("|")])])], 1) : _vm._e(), _vm._v(" "), (_vm.failed.length > 0) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Download Failed Config")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": 'Download Failed ' + _vm.configTypeLabel,
      "target": "_blank"
    },
    on: {
      "click": _vm.exportFailedConfig
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0"
    }
  }, [_vm._v("Download\n                          "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px",
      "color": "red"
    }
  })])])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "submit",
      "title": 'Upload ' + _vm.configTypeLabel + ' File For Selected Hub',
      "disabled": _vm.isdisableupload
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), _c('b-card', {
    staticClass: "mt-3"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingConfigData
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingConfigData = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    style: (_vm.configDataList.length > 12 ? 'overflow: auto; height: 395px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.configIdLabel))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.configNameLabel))]), _vm._v(" "), (_vm.configType === 'area') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.configMeta.typeHeader))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.configMeta.qrHeader))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.configDataList), function(data, index) {
    return _c('tr', {
      key: data.id || index
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s((_vm.pageNo * _vm.pageSize) + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.getHubNameValue(data)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.getConfigIdValue(data)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.getConfigNameValue(data)))]), _vm._v(" "), (_vm.configType === 'area') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.getTypeValue(data)))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.getQrValue(data)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.isActive) ? _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v("Active")]) : _c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v("Inactive")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-edit text-successedit fa-lg",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": 'Toggle ' + _vm.configTypeLabel + ' status'
      },
      on: {
        "click": function($event) {
          return _vm.openStatusModal(data)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.configDataList.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": _vm.listColumnCount
    }
  }, [_vm._v("No records found.")])]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.totalRows > 0 && _vm.totalRows > _vm.pageSize) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentTab === 'history') ? _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingHistory
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingHistory = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    style: (_vm.fileDetails.length > 12 ? 'overflow: auto; height: 395px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("File Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("File Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Uploaded By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Uploaded Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.fileDetails), function(data, index) {
    return (_vm.fileDetails.length > 0) ? _c('tr', {
      key: data.id || index
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s((_vm.historyPageNo * _vm.historyPageSize) + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.filename))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.filetype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.uploaded_by))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment1")(data.uploaded_at)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.fileDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.historyTotalRows > 0 && _vm.historyTotalRows > _vm.historyPageSize) ? _c('div', {
    staticClass: "history-pagination-wrap"
  }, [_c('paginate', {
    attrs: {
      "page-count": _vm.historyPageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getHistoryPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.currentTab === 'report') ? _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingReport
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingReport = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row report-mode-row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "radio-inline config-type-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportMode),
      expression: "reportMode"
    }],
    attrs: {
      "type": "radio",
      "name": "reportMode",
      "value": "trolley"
    },
    domProps: {
      "checked": _vm._q(_vm.reportMode, "trolley")
    },
    on: {
      "change": [function($event) {
        _vm.reportMode = "trolley"
      }, _vm.onReportModeChange]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "config-type-radio-label"
  }, [_vm._v("Trolley Search")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline config-type-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportMode),
      expression: "reportMode"
    }],
    attrs: {
      "type": "radio",
      "name": "reportMode",
      "value": "bags"
    },
    domProps: {
      "checked": _vm._q(_vm.reportMode, "bags")
    },
    on: {
      "change": [function($event) {
        _vm.reportMode = "bags"
      }, _vm.onReportModeChange]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "config-type-radio-label"
  }, [_vm._v("Bags Search")])])])]), _vm._v(" "), (_vm.reportMode === 'trolley') ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Select Trolley(s) "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "report-search-actions trolley-select-actions"
  }, [_c('div', {
    staticClass: "trolley-report-multiselect-wrap"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.eligibleTrolleys,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "searchable": true,
      "show-labels": false,
      "custom-label": _vm.getTrolleyDropdownLabel,
      "track-by": "movementId",
      "placeholder": _vm.eligibleTrolleys.length ? 'Select trolley(s)' : 'No open trolleys'
    },
    model: {
      value: (_vm.selectedTrolleys),
      callback: function($$v) {
        _vm.selectedTrolleys = $$v
      },
      expression: "selectedTrolleys"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "button",
      "disabled": !_vm.canSearchTrolleysReport
    },
    on: {
      "click": _vm.searchTrolleysReport
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetTrolleySearch
    }
  }, [_vm._v("\n                      Reset\n                    ")])])])]), _vm._v(" "), (_vm.trolleySearchSummaries.length) ? _c('div', {
    staticClass: "report-summary-box"
  }, _vm._l((_vm.trolleySearchSummaries), function(summary, summaryIndex) {
    return _c('div', {
      key: summary.movementId,
      staticClass: "row",
      class: {
        'mt-2': summaryIndex > 0
      }
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('strong', [_vm._v("Trolley ID:")]), _vm._v(" " + _vm._s(summary.trolleyId))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('strong', [_vm._v("Status:")]), _vm._v(" " + _vm._s(summary.movementStatus))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('strong', [_vm._v("From Area:")]), _vm._v(" " + _vm._s(summary.fromAreaId || '--'))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('strong', [_vm._v("Bag Count:")]), _vm._v(" " + _vm._s(summary.bagCount))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 mt-2"
    }, [_c('strong', [_vm._v("Started:")]), _vm._v(" " + _vm._s(_vm.formatReportDate(summary.movementStartedAt)) + "\n                  ")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "mt-3"
  }, [(_vm.trolleyBags.length > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 report-actions-row"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "button",
      "disabled": !_vm.canDownloadTrolleyReport
    },
    on: {
      "click": _vm.downloadTrolleyReportCsv
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download CSV\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    style: (_vm.trolleyBags.length > 12 ? 'overflow: auto; height: 395px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), (_vm.showTrolleyIdInReport) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Trolley ID")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Loaded By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Loaded At")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Last Modified By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Last Modified At")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.trolleyBags), function(bag, index) {
    return _c('tr', {
      key: (bag.movementId || '') + '-' + (bag.bagId || index)
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s((_vm.trolleyBagPageNo * _vm.trolleyBagPageSize) + index + 1))]), _vm._v(" "), (_vm.showTrolleyIdInReport) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(bag.trolleyId || '--'))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(bag.bagId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(bag.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(bag.createdBy || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatReportDate(bag.createdDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(bag.lastModifiedBy || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatReportDate(bag.lastModifiedDate)))])])
  }), _vm._v(" "), (_vm.lastSearchedMovementIds.length && _vm.trolleyBags.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": _vm.trolleyBagColumnCount
    }
  }, [_vm._v("No records found.")])]) : _vm._e(), _vm._v(" "), (!_vm.lastSearchedMovementIds.length) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": _vm.trolleyBagColumnCount
    }
  }, [_vm._v("Select trolley(s) and click Search to view bag details.")])]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.trolleyBagTotalRows > 0 && _vm.trolleyBagTotalRows > _vm.trolleyBagPageSize) ? _c('paginate', {
    attrs: {
      "page-count": _vm.trolleyBagPageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getTrolleyBagPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)], 1) : _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Bag Number(s) "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagSearchInput),
      expression: "bagSearchInput"
    }],
    staticClass: "form-control report-bag-textarea",
    attrs: {
      "rows": "4",
      "placeholder": "Enter bag numbers separated by commas, e.g. pnq0001234, pnq0005678"
    },
    domProps: {
      "value": (_vm.bagSearchInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagSearchInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Enter one or more bag numbers separated by commas.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 report-search-actions"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchBagsReport
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetBagSearch
    }
  }, [_vm._v("\n                    Reset\n                  ")])])]), _vm._v(" "), _c('b-card', {
    staticClass: "mt-3"
  }, [(_vm.bagSearchResults.length > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 report-actions-row"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "button",
      "disabled": !_vm.canDownloadBagSearchReport
    },
    on: {
      "click": _vm.downloadBagSearchReportCsv
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download CSV\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    style: (_vm.bagSearchResults.length > 12 ? 'overflow: auto; height: 395px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Trolley ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Movement Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("From Area")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("To Area")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Loaded By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Loaded At")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Movement Started At")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.bagSearchResults), function(row, index) {
    return _c('tr', {
      key: row.bagId || index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s((_vm.bagSearchPageNo * _vm.bagSearchPageSize) + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.bagId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.trolleyId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.movementStatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.fromAreaId || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.toAreaId || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.bagStatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.loadedBy || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatReportDate(row.loadedAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatReportDate(row.movementStartedAt)))])])
  }), _vm._v(" "), (_vm.bagSearchResults.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": _vm.bagSearchColumnCount
    }
  }, [_vm._v("No records found.")])]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.bagSearchTotalRows > 0 && _vm.bagSearchTotalRows > _vm.bagSearchPageSize) ? _c('paginate', {
    attrs: {
      "page-count": _vm.bagSearchPageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getBagSearchPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentTab === 'print') ? _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingPrint
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPrint = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.configMeta.qrHeader))]), _vm._v(" "), (_vm.hasQrSelection) ? _c('div', {
    staticClass: "bin-pallet-selected-box"
  }, [(_vm.checkAllQr) ? _c('span', {
    staticClass: "bin-pallet-selected-box__chip"
  }, [_c('span', [_vm._v(_vm._s(_vm.qrSelectionSummaryLabel))]), _vm._v(" "), _c('i', {
    staticClass: "bin-pallet-selected-box__remove",
    attrs: {
      "aria-hidden": "true",
      "tabindex": "1"
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.clearAllQrSelection.apply(null, arguments)
      }
    }
  })]) : [_vm._l((_vm.displayedQrChips), function(option, index) {
    return _c('span', {
      key: ((option.id) + "-" + index),
      staticClass: "bin-pallet-selected-box__chip"
    }, [_c('span', [_vm._v(_vm._s(option.text))]), _vm._v(" "), _c('i', {
      staticClass: "bin-pallet-selected-box__remove",
      attrs: {
        "aria-hidden": "true",
        "tabindex": "1"
      },
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          return _vm.removeSelectedQr(option)
        }
      }
    })])
  }), _vm._v(" "), (_vm.remainingQrChipCount > 0) ? _c('span', {
    staticClass: "bin-pallet-selected-box__chip bin-pallet-selected-box__chip--summary"
  }, [_vm._v("\n                              +" + _vm._s(_vm.remainingQrChipCount) + " more\n                            ")]) : _vm._e()]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bin-pallet-multiselect-wrap"
  }, [_c('multiselect', {
    ref: "qrMultiselect",
    attrs: {
      "options": _vm.dropdownQrOptions,
      "multiple": true,
      "searchable": true,
      "internal-search": false,
      "hide-selected": false,
      "close-on-select": false,
      "show-labels": false,
      "placeholder": 'Select ' + _vm.configMeta.qrHeader,
      "label": "text",
      "track-by": "id",
      "name": "printQr"
    },
    on: {
      "search-change": _vm.onQrSearchChange,
      "input": _vm.syncCheckAllQr
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;

        return [_c('div', {
          staticClass: "multiselect__tags-wrap bin-pallet-hidden-selected-tags"
        })]
      }
    }, {
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "bin-pallet-option",
          class: {
            'bin-pallet-option--locked': _vm.checkAllQr
          },
          on: {
            "mousedown": function($event) {
              $event.preventDefault();
            },
            "click": function($event) {
              $event.stopPropagation();
              return _vm.onQrOptionClick(props.option)
            }
          }
        }, [_c('span', {
          staticClass: "bin-pallet-checkbox",
          class: {
            'bin-pallet-checkbox--checked': _vm.isQrSelected(props.option)
          },
          attrs: {
            "aria-hidden": "true"
          }
        }, [_c('span', {
          staticClass: "bin-pallet-checkbox__mark"
        }, [_vm._v("✓")])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.option.text))])])]
      }
    }], null, false, 3558835607),
    model: {
      value: (_vm.selectedQrItems),
      callback: function($$v) {
        _vm.selectedQrItems = $$v
      },
      expression: "selectedQrItems"
    }
  }, [_vm._v(" "), _c('template', {
    slot: "beforeList"
  }, [_c('div', {
    staticClass: "bin-pallet-select-all",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.toggleCheckAllQr.apply(null, arguments)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.checkAllQr
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.allQrLabel))])]), _vm._v(" "), (_vm.checkAllQr) ? _c('div', {
    staticClass: "bin-pallet-dropdown-hint"
  }, [_vm._v("\n                                All items are selected. Clear the selection chip above to pick individual items.\n                              ")]) : (_vm.qrDropdownTruncated) ? _c('div', {
    staticClass: "bin-pallet-dropdown-hint"
  }, [_vm._v("\n                                Showing first " + _vm._s(_vm.dropdownQrOptions.length) + " of " + _vm._s(_vm.qrDropdownTotalCount) + ". Refine your search to narrow results.\n                              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bin-pallet-search-actions"
  }, [_c('button', {
    staticClass: "bin-pallet-search-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.qrSearchActionCount === 0
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      },
      "click": _vm.selectAllQrFromSearch
    }
  }, [_vm._v("\n                                  Select all from search (" + _vm._s(_vm.qrSearchActionCount) + ")\n                                ")]), _vm._v(" "), _c('button', {
    staticClass: "bin-pallet-search-btn",
    attrs: {
      "type": "button",
      "disabled": !_vm.hasActiveQrSearch || _vm.qrSearchActionCount === 0 || _vm.checkAllQr
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      },
      "click": _vm.deselectAllQrFromSearch
    }
  }, [_vm._v("\n                                  Deselect all from search (" + _vm._s(_vm.qrSearchActionCount) + ")\n                                ")])])])], 2)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.printLoadingMessage))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 d-flex align-items-flex-end"
  }, [_c('div', {
    staticClass: "action-buttons"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.printQRs
    }
  }, [_vm._v("Print QR Codes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.resetPrint();
        _vm.loadPrintData();
      }
    }
  }, [_vm._v("Reset")])])])])])])], 1), _vm._v(" "), _c('div', {
    style: (_vm.paginatedQrPreviewList.length > 8 ? 'overflow: auto; height: 395px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.configIdLabel))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.configNameLabel))]), _vm._v(" "), (_vm.configType === 'area') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.configMeta.typeHeader))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.configMeta.qrHeader))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.paginatedQrPreviewList), function(data, index) {
    return _c('tr', {
      key: data.id || index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s((_vm.qrPageNo * _vm.qrPageSize) + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.getConfigIdValue(data)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.getConfigNameValue(data)))]), _vm._v(" "), (_vm.configType === 'area') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.getTypeValue(data)))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center qr-preview-cell"
    }, [_vm._v(_vm._s(_vm.getQrValue(data)))])])
  }), _vm._v(" "), (_vm.qrPreviewList.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": _vm.configType === 'area' ? 5 : 4
    }
  }, [_vm._v("No records found.")])]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.qrTotalRows > 0 && _vm.qrTotalRows > _vm.qrPageSize) ? _c('paginate', {
    attrs: {
      "page-count": _vm.qrPageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getQrPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "configStatusModal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.statusModalShow),
      callback: function($$v) {
        _vm.statusModalShow = $$v
      },
      expression: "statusModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.selectedConfigRow) ? _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("\n            Do you want to mark\n            "), _c('strong', [_vm._v(_vm._s(_vm.getConfigIdValue(_vm.selectedConfigRow)))]), _vm._v("\n            as\n            "), _c('strong', [_vm._v(_vm._s(_vm.selectedConfigRow.isActive ? 'Inactive' : 'Active'))]), _vm._v("?\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleConfigActive
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84b9d1e8","hasScoped":true}!./src/views/components/TrolleyConfig/TrolleyConfig.html
// module id = 1918
// module chunks = 2